export default __webpack_public_path__ + "static/media/settings.ed7c42a6.svg";